import ComingSoon from 'src/containers/ComingSoon/ComingSoon';

export default ComingSoon;